import { COMPOSE_ONLY_CONTENT_END, COMPOSE_ONLY_CONTENT_START } from './pluginConstants';
import { SUGGESTION_CLASS } from '../store/schema/Suggestion';

const contentToRemove = new RegExp(
    `<!--${COMPOSE_ONLY_CONTENT_START}-->.*?<!--${COMPOSE_ONLY_CONTENT_END}-->`,
    'gim'
);

export default function removeComposeOnlyContent(clonedRoot: HTMLElement): void {
    if (clonedRoot) {
        const suggestionElements = clonedRoot.querySelectorAll(`.${SUGGESTION_CLASS}`);
        for (let i = 0; i < suggestionElements?.length; i++) {
            const suggestionElement = suggestionElements[0];
            if (suggestionElement?.parentNode) {
                suggestionElement.parentNode.removeChild(suggestionElement);
            }
        }
    }
}

export function containsComposeOnlyContent(html: string): boolean {
    return contentToRemove.test(html);
}
